var e = e || {},
    avanti = avanti || {};
( function () {
    'use strict';
    jQuery( function () {
        avanti.init();
    } );
    avanti.init = function () {
        avanti.detectCountry.init();
        avanti.requestTrainingForm.init();
    };
    avanti.detectCountry = {
        loadAPI: function ( strCallback ) {
            var gm = document.createElement( 'script' ),
                script = document.getElementsByTagName( 'script' )[ 0 ];
            gm.src = '//maps.google.com/maps/api/js?callback=' + strCallback;
            script.parentNode.insertBefore( gm, script );
        },
        checkLocal: function () {
            var localData = sessionStorage.egeolocation;
            if ( localData ) {
                this.showList( localData );
            }
            else {
                this.detectIp_io();
            }
        },
        detectIp_io: function () {
            var jThis = this,
                checkForTimeout = setTimeout( function () {
                    jThis.showList( '' );
                }, 20000 );
            jQuery.get( '//ipinfo.io', function ( response ) {
                //console.log( response );
                if ( response ) {
                    clearTimeout( checkForTimeout );
                    sessionStorage.egeolocation = response.country;
                    jThis.showList( response.country );
                }
            }, 'jsonp' );
        },
        /*
        detectIp_gm: function () {
            var jThis = this,
                checkForTimeout = setTimeout( function () {
                    jThis.showList( '' );
                }, 20000 );
            if ( navigator.geolocation ) {
                navigator.geolocation.getCurrentPosition( function ( jPosition ) {
                    var jPoint = new google.maps.LatLng( jPosition.coords.latitude, jPosition.coords.longitude );
                    new google.maps.Geocoder().geocode( {
                        'latLng': jPoint
                    }, function ( res, status ) {
                        if ( status === google.maps.GeocoderStatus.OK && typeof res[ 0 ] !== 'undefined' ) {
                            clearTimeout( checkForTimeout );
                            localStorage.setItem( 'e-geolocation', res[ 0 ].address_components[ 4 ].short_name );
                            jThis.showList( res[ 0 ].address_components[ 4 ].short_name );
                        }
                    } );
                } );
            }
            else {
                jThis.showList( '' );
            }
        },
        */
        showList: function ( jCountry ) {
            var jList = jQuery( '.avanti-ip-contact-list' );
            jList.each( function () {
                var jThis = jQuery( this ),
                    jCountrieItems = jThis.find( '.contact-list-item[data-country]' ),
                    jIndex = 0;
                jCountrieItems.each( function () {
                    var jThisCountries = jQuery( this ).data( 'country' ).replace( ' ', '' ),
                        jThisCountriesArr = jThisCountries.split( ',' );
                    if ( jQuery.inArray( jCountry, jThisCountriesArr ) > -1 ) {
                        if ( jIndex <= 3 ) {
                            jQuery( this ).fadeIn( 'slow' );
                        }
                        jIndex++;
                    }
                } );
                if ( jIndex === 0 ) {
                    jThis.find( '.contact-list-item[data-global="True"]' ).each( function ( index ) {
                        if ( index <= 3 ) {
                            jQuery( this ).fadeIn( 'slow' );
                        }
                    } );
                }
            } );
        },
        setCountryManually: function () {
            if ( e.util.param.setcountry ) {
                sessionStorage.egeolocation = e.util.param.setcountry;
            }
        },
        init: function () {
            this.setCountryManually();
            if ( jQuery( '#avanti-ip-contact-list' ).length > 0 ) {
                this.checkLocal();
            }
        }
    };
    avanti.requestTrainingForm = {};
    avanti.requestTrainingForm.init = function () {
        jQuery( '.js-avanti-location-onsite' ).on( 'click', function () {
            jQuery( '.js-avanti-specify-city-country' ).show();
            jQuery( '.js-avanti-specify-city-country' ).find( 'input' ).addClass( 'required' );
            jQuery( '.js-avanti-specify-city-country' ).find( 'input.js-avanti-state' ).removeClass( 'required' );
        } );
        jQuery( '.js-avanti-location-avantiloc' ).on( 'click', function () {
            jQuery( '.js-avanti-specify-city-country' ).hide();
            jQuery( '.js-avanti-specify-city-country' ).find( 'input' ).removeClass( 'required' );
        } );
        jQuery( '#EcomOrderLineFieldInput_NumberOfDelegates' ).on( 'change', function () {
            var selectVal = jQuery( this ).val();
            if ( selectVal === '' ) {
                jQuery( '.js-avanti-delegate1, .js-avanti-delegate2, .js-avanti-delegate3, .js-avanti-delegate4, .js-avanti-delegate5, .js-avanti-delegate6, .js-avanti-delegate7, .js-avanti-delegate8, .js-avanti-delegate9, .js-avanti-delegate10, .js-avanti-morethan10' ).hide();
            }
            if ( selectVal === '1' ) {
                jQuery( '.js-avanti-delegate1' ).show();
                jQuery( '.js-avanti-delegate2, .js-avanti-delegate3, .js-avanti-delegate4, .js-avanti-delegate5, .js-avanti-delegate6, .js-avanti-delegate7, .js-avanti-delegate8, .js-avanti-delegate9, .js-avanti-delegate10, .js-avanti-morethan10' ).hide();
            }
            if ( selectVal === '2' ) {
                jQuery( '.js-avanti-delegate1, .js-avanti-delegate2' ).show();
                jQuery( '.js-avanti-delegate3, .js-avanti-delegate4, .js-avanti-delegate5, .js-avanti-delegate6, .js-avanti-delegate7, .js-avanti-delegate8, .js-avanti-delegate9, .js-avanti-delegate10, .js-avanti-morethan10' ).hide();
            }
            if ( selectVal === '3' ) {
                jQuery( '.js-avanti-delegate1, .js-avanti-delegate2, .js-avanti-delegate3' ).show();
                jQuery( '.js-avanti-delegate4, .js-avanti-delegate5, .js-avanti-delegate6, .js-avanti-delegate7, .js-avanti-delegate8, .js-avanti-delegate9, .js-avanti-delegate10, .js-avanti-morethan10' ).hide();
            }
            if ( selectVal === '4' ) {
                jQuery( '.js-avanti-delegate1, .js-avanti-delegate2, .js-avanti-delegate3, .js-avanti-delegate4' ).show();
                jQuery( '.js-avanti-delegate5, .js-avanti-delegate6, .js-avanti-delegate7, .js-avanti-delegate8, .js-avanti-delegate9, .js-avanti-delegate10, .js-avanti-morethan10' ).hide();
            }
            if ( selectVal === '5' ) {
                jQuery( '.js-avanti-delegate1, .js-avanti-delegate2, .js-avanti-delegate3, .js-avanti-delegate4, .js-avanti-delegate5' ).show();
                jQuery( '.js-avanti-delegate6, .js-avanti-delegate7, .js-avanti-delegate8, .js-avanti-delegate9, .js-avanti-delegate10, .js-avanti-morethan10' ).hide();
            }
            if ( selectVal === '6' ) {
                jQuery( '.js-avanti-delegate1, .js-avanti-delegate2, .js-avanti-delegate3, .js-avanti-delegate4, .js-avanti-delegate5, .js-avanti-delegate6' ).show();
                jQuery( '.js-avanti-delegate7, .js-avanti-delegate8, .js-avanti-delegate9, .js-avanti-delegate10, .js-avanti-morethan10' ).hide();
            }
            if ( selectVal === '7' ) {
                jQuery( '.js-avanti-delegate1, .js-avanti-delegate2, .js-avanti-delegate3, .js-avanti-delegate4, .js-avanti-delegate5, .js-avanti-delegate6, .js-avanti-delegate7' ).show();
                jQuery( '.js-avanti-delegate8, .js-avanti-delegate9, .js-avanti-delegate10, .js-avanti-morethan10' ).hide();
            }
            if ( selectVal === '8' ) {
                jQuery( '.js-avanti-delegate1, .js-avanti-delegate2, .js-avanti-delegate3, .js-avanti-delegate4, .js-avanti-delegate5, .js-avanti-delegate6, .js-avanti-delegate7, .js-avanti-delegate8' ).show();
                jQuery( '.js-avanti-delegate9, .js-avanti-delegate10, .js-avanti-morethan10' ).hide();
            }
            if ( selectVal === '9' ) {
                jQuery( '.js-avanti-delegate1, .js-avanti-delegate2, .js-avanti-delegate3, .js-avanti-delegate4, .js-avanti-delegate5, .js-avanti-delegate6, .js-avanti-delegate7, .js-avanti-delegate8, .js-avanti-delegate9' ).show();
                jQuery( '.js-avanti-delegate10, .js-avanti-morethan10' ).hide();
            }
            if ( selectVal === '10' ) {
                jQuery( '.js-avanti-delegate1, .js-avanti-delegate2, .js-avanti-delegate3, .js-avanti-delegate4, .js-avanti-delegate5, .js-avanti-delegate6, .js-avanti-delegate7, .js-avanti-delegate8, .js-avanti-delegate9, .js-avanti-delegate10' ).show();
                jQuery( '.js-avanti-morethan10' ).hide();
            }
            if ( selectVal === 'morethan10' ) {
                jQuery( '.js-avanti-morethan10' ).show();
                jQuery( '.js-avanti-delegate1, .js-avanti-delegate2, .js-avanti-delegate3, .js-avanti-delegate4, .js-avanti-delegate5, .js-avanti-delegate6, .js-avanti-delegate7, .js-avanti-delegate8, .js-avanti-delegate9, .js-avanti-delegate10' ).hide();
            }
        } );
    };
    e.ecom.productdetails.validation = function () {
        jQuery( '.js-e-add-to-cart-form' ).validate( {
            errorClass: 'text-error',
            errorElement: 'p',
            errorPlacement: function ( error, element ) {
                console.log(element.type);
                if (element.attr('type') === 'radio') {
                    error.appendTo( element.closest( 'div.control-group' ) );
                } else {
                    error.appendTo( element.closest( 'div' ) );
                }
            },
            highlight: function ( element, errorClass ) {
                jQuery( element ).addClass( errorClass );
            },
            unhighlight: function ( element, errorClass ) {
                jQuery( element ).removeClass( errorClass );
            },
            submitHandler: function ( form ) {
                form.submit();
            }
        } );
    };
}() );
